module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_01_770_280_zh-hant-d893a9ef5d0289af30993ae79800533e.jpg";